/**
 * Collapsed-by-default raw view of the intermediate JSON `PlotMatrixJsonTable`
 * renders from — makes the "build JSON first" step of this dev tool visible
 * and inspectable, not just an internal implementation detail.
 */
import React from "react";
import { Collapse } from "antd";
import type { PlotMatrixJsonResult } from "../../../../utils/plotMatrixJsonBuilder";

export interface PlotMatrixJsonViewerProps {
  json: PlotMatrixJsonResult;
}

const PlotMatrixJsonViewer: React.FC<PlotMatrixJsonViewerProps> = ({ json }) => (
  <Collapse
    style={{ marginBottom: 12 }}
    items={[
      {
        key: "raw-json",
        label: `View generated JSON (${json.rows.length} rows × ${json.columns.length} columns)`,
        children: (
          <pre
            style={{
              maxHeight: 400,
              overflow: "auto",
              fontSize: 12,
              background: "#fafafa",
              padding: 12,
              margin: 0,
            }}
          >
            {JSON.stringify(json, null, 2)}
          </pre>
        ),
      },
    ]}
  />
);

export default PlotMatrixJsonViewer;
